module.exports = __webpack_public_path__ + "img/usp_icon3.7983902f.svg";